import Slides from './Slides.js';

import img1 from './images/portfolio/weddings-and-engagements/5/Img020.jpg';
import img2 from './images/portfolio/weddings-and-engagements/5/Img068.jpg';
import img3 from './images/portfolio/weddings-and-engagements/5/Img117.jpg';
import img4 from './images/portfolio/weddings-and-engagements/5/Img156.jpg';
import img5 from './images/portfolio/weddings-and-engagements/5/Img190.jpg';
import img6 from './images/portfolio/weddings-and-engagements/5/Img207.jpg';
import img7 from './images/portfolio/weddings-and-engagements/5/Img245.jpg';
import img8 from './images/portfolio/weddings-and-engagements/5/Img333.jpg';
import img9 from './images/portfolio/weddings-and-engagements/5/KK_master.jpg';
import img10 from './images/portfolio/weddings-and-engagements/5/Pete_Wilders.jpg';
import img11 from './images/portfolio/weddings-and-engagements/5/TnB0030.jpg';
import img12 from './images/portfolio/weddings-and-engagements/5/TnB0413.jpg';
import img13 from './images/portfolio/weddings-and-engagements/5/TnB0445.jpg';
import img14 from './images/portfolio/weddings-and-engagements/5/TnB0475.jpg';
import img15 from './images/portfolio/weddings-and-engagements/5/TnB0481.jpg';
import img16 from './images/portfolio/weddings-and-engagements/5/TnB0719.jpg';
import img17 from './images/portfolio/weddings-and-engagements/5/_498.jpg';
import img18 from './images/portfolio/weddings-and-engagements/5/_DSC0085.jpg';
import img19 from './images/portfolio/weddings-and-engagements/5/_DSC7381.jpg';
import img20 from './images/portfolio/weddings-and-engagements/5/_DSC7414.jpg';
import img21 from './images/portfolio/weddings-and-engagements/5/_DSC7470.jpg';
import img22 from './images/portfolio/weddings-and-engagements/5/_DSC7505.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
];

function Architectural() {
    return <Slides images={images}/>;
}

export default Architectural;
